import type { TourDefinition } from '../types';

export const dealsTour: TourDefinition = {
  id: 'deals',
  title: 'Negócios',
  steps: [
    {
      element: '[data-tour="deals-pipeline-selector"]',
      popover: {
        title: 'Seletor de Pipeline',
        description:
          'Escolha o pipeline que deseja visualizar. Você pode criar múltiplos pipelines.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="deals-create-btn"]',
      popover: {
        title: 'Novo Negócio',
        description:
          'Crie um novo negócio e associe a um lead e etapa do pipeline.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="deals-view-toggles"]',
      popover: {
        title: 'Modos de Visualização',
        description:
          'Alterne entre Kanban, Lista e Previsão para diferentes perspectivas dos seus negócios.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="deals-kanban-columns"]',
      popover: {
        title: 'Colunas do Kanban',
        description:
          'Arraste negócios entre etapas. Cada coluna representa uma fase do seu pipeline.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
